import { useTranslation } from 'react-i18next';
import HeaderJourney from '../../storybook/Header/HeaderJourney';
import { detectMobile, formatDateWithFullMonthWeekInLetters, isNullOrUndefined } from '../../utils/formatting';
import { useDispatch, useSelector } from 'react-redux';
import { CasePriority, RepairPriorityCode } from '../../models/Repair/RepairPriority';
import Button from "../../storybook/Button";
import './index.css';
import { calendarPageIndex, DMCChecksavedAnswer, dmcRepairAppointmentData, dmcRepairAppointmentWillNotBeCreated, dmcRepairSelectedSlotData, originalRepairAppointmentData, originalRepairAppointmentWillNotBeCreated, originalRepairSelectedSlotData, showFooter, showMenuTabs, userChosenAdditionalDescription, userChosenAdditionalDescriptionCOUNT, userNavigatedFrom } from '../../ducks/redux/actions/userChoices';
import { comingFromRepairJourneySuccess, RemoveAllDMCData, saveSelectedSlotDate, savingCalenderIndex, savingcalenderTrackValue, savingDmcCalenderIndex, savingDmcCalenderTrackValue, setTriageRepair } from '../../ducks/redux/actions/FinancialReferral';
import { dmcWorkOrderRepairObject, getDeterminedContractorDetails, workOrderRepairObject } from '../../ducks/redux/actions/getAddress';
import moment from 'moment';
import { useEffect } from 'react';
import React from 'react';
import MWF from "../../assets/icons/Multiple-WO-Fail-Icon.png";
import MWP from "../../assets/icons/Multiple-WO-Partial-Icon.png";
import MWS from "../../assets/icons/Multiple-WO-Success-Icon.png";

const RepairFinalDetails: React.FC<any> = (props) => {
    const workOrderObject = useSelector(
        (state: any) => state.addresses.workOrderRepair
    );
    const referenceNumberCode = useSelector(
        (state: any) => state.addresses?.referenceno
    );
    const userGetRepairDataValue = useSelector(
        (state: any) => state?.userChoicesReducer?.userGetRepairData
    );
    const determinedcontractordetails = useSelector(
        (state: any) => state.addresses?.determinedcontractordetails
    );
    const dmcWOObject = useSelector(
        (state: any) => state.addresses.dmcWorkOrderRepair
    );
    const originalRepairSelectedSlotValue = useSelector(
        (state: any) => state?.userChoicesReducer?.originalRepairSelectedSlot
    );
    const dmcRepairSelectedSlotValue = useSelector(
        (state: any) => state?.userChoicesReducer?.dmcRepairSelectedSlot
    );
    const isCatalystCustomer = useSelector(
        (state: any) => state.userChoicesReducer?.isCatalystCustomer
    );
    const eligibilityResponseObject = useSelector(
        (state: any) => state?.dashboardReducer?.formState?.eligibilityResponseObject
    );
    const dmcInspectionSorCodes = useSelector(
        (state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues
    );
    const userChosenSOR = useSelector(
        (state: any) => state.userChoicesReducer.userChosenSOR
    );
    const userChosenDuplicateQuestion = useSelector((state: any) => state?.userChoicesReducer?.userChosenDuplicateQuestion);
    const heatinghotwatercase = useSelector((state: any) => state?.addresses?.heatinghotwatercase);
    const selectedSorCodeValue = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
    const vulnerabilityAdditionalInformation = useSelector((state: any) => state.userChoicesReducer.userChosenVulnerabilityAdditionalInformation);
    const vulnerabilityExcludedSorcodes = useSelector((state: any) => state?.userChoicesReducer?.vulnerabilityExcludedSorcodeValues);

    const isPropertyInDefect = eligibilityResponseObject?.statuses?.isInDefects === true;
    const isCatalystDefectTriageCase = isCatalystCustomer && isPropertyInDefect;
    const [isTriageCase, SetisTriageCase] = React.useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    let originalWOJobNumber = '';
    let originalWODescription = '';
    let originalWOPriority = '';
    let dmcWOJobNumber = '';
    if (!isNullOrUndefined(workOrderObject)) {
        originalWOJobNumber = workOrderObject?.jobNo;
        originalWODescription = workOrderObject?.repairReason;
        originalWOPriority = workOrderObject?.priority;
        dmcWOJobNumber = workOrderObject?.associatedWorkOrdersJobNumber;
    }
    else {
        originalWOJobNumber = referenceNumberCode;
        originalWODescription = userGetRepairDataValue?.description;
        originalWOPriority = userGetRepairDataValue?.priority;
        dmcWOJobNumber = userGetRepairDataValue?.associatedWorkOrdersJobNumber;
    }
    // Hiding menu tabs and footer for this page
    useEffect(() => {
        if (!isNullOrUndefined(userChosenDuplicateQuestion)
            || !isNullOrUndefined(heatinghotwatercase)
            || (!isNullOrUndefined(vulnerabilityAdditionalInformation)
                && (!vulnerabilityExcludedSorcodes?.includes(selectedSorCodeValue)))) {
            SetisTriageCase(true);
        }
        dispatch(showMenuTabs(false));
        dispatch(showFooter(false));
    }, []);

    let originalWoStartDate = '';
    let originalWoEndDate = '';
    let dmcWoStartDate = '';
    let dmcWoEndDate = '';

    if (!isNullOrUndefined(originalRepairSelectedSlotValue)) {
        originalWoStartDate = moment(originalRepairSelectedSlotValue?.start, ["HH.mm"]).format("hh:mm a");
        originalWoEndDate = moment(originalRepairSelectedSlotValue?.end, ["HH.mm"]).format("hh:mm a");
    }

    if (!isNullOrUndefined(dmcRepairSelectedSlotValue)) {
        dmcWoStartDate = moment(dmcRepairSelectedSlotValue?.start, ["HH.mm"]).format("hh:mm a");
        dmcWoEndDate = moment(dmcRepairSelectedSlotValue?.end, ["HH.mm"]).format("hh:mm a");
    }
    const originalWOAppointmentDate = formatDateWithFullMonthWeekInLetters(new Date(originalRepairSelectedSlotValue?.date).toDateString()) + ' (' + originalRepairSelectedSlotValue?.availabilityTypeLabel + ' ' + (originalWoStartDate + '-' + originalWoEndDate) + ')';
    const dmcWOAppointmentDate = formatDateWithFullMonthWeekInLetters(new Date(dmcRepairSelectedSlotValue?.date).toDateString()) + ' (' + dmcRepairSelectedSlotValue?.availabilityTypeLabel + ' ' + (dmcWoStartDate + '-' + dmcWoEndDate) + ')';

    let woSummaryHeading = '';
    let woSubSummaryHeading = '';

    if (((!isNullOrUndefined(originalWOJobNumber) || isCatalystDefectTriageCase)
        && !isNullOrUndefined(dmcWOJobNumber)) || (!isNullOrUndefined(originalWOJobNumber)
            && isPropertyInDefect && isNullOrUndefined(dmcWOObject)) || (isCatalystDefectTriageCase
                && isNullOrUndefined(dmcWOObject))) {
        woSummaryHeading = t('Multi_WO_Success_Heading');
    }
    else if (isNullOrUndefined(originalWOJobNumber) && isNullOrUndefined(dmcWOJobNumber) && !isTriageCase) {
        woSummaryHeading = t('Multi_WO_Failure_Heading');
        woSubSummaryHeading = t('Multi_WO_Failure_SubHeading');
    }
    else {
        woSummaryHeading = t('Multi_WO_Partial_Success_Heading');
        if (isNullOrUndefined(dmcWOJobNumber) && !isNullOrUndefined(originalWOJobNumber)) {
            woSubSummaryHeading = t('DMC_WO_Failure_SubHeading');
        }
        else if (isNullOrUndefined(dmcWOJobNumber) && isTriageCase) {
            woSubSummaryHeading = t('Original_WO_Triage_DMC_Fail_SubHeading');
        }
        else {
            if (isTriageCase) {
                woSubSummaryHeading = t('Original_WO_Triage_SubHeading');
            }
            else {
                woSubSummaryHeading = t('Original_WO_Failure_SubHeading');
            }
        }
    }

    let originalWoReferenceToShow = !isNullOrUndefined(originalWOJobNumber)
        ? 'Reference ' + originalWOJobNumber
        : isCatalystDefectTriageCase
            ? t("Multi_WO_CatalystDefectTriage_Reference")
            : (isTriageCase || determinedcontractordetails?.statuses?.isEMA && workOrderObject?.isCatalyst)
                ? t("Multi_WO_Triage_Reference")
                : t("Multi_WO_Failed_Reference");

    const dmcReferenceToShow = !isNullOrUndefined(dmcWOJobNumber)
        ? 'Reference ' + dmcWOJobNumber : t("Multi_WO_Failed_Reference");

    const isMobile = detectMobile();

    const returnToHomeButtonHandler = () => {
        resetDispatcherFields();
        props.history.push("/customer360View")
    };
    const openMobiledialer = () => {
        window.open('tel:' + t('phone_no'));
    };

    const requestAnotherRepairButtonHandler = () => {
        resetDispatcherFields();
        props.history.push("/repairproperty");
    }

    const returnToRepairHistory = () => {
        resetDispatcherFields();
        props.history.push("/historicRepairs")
    };

    const resetDispatcherFields = () => {
        dispatch(comingFromRepairJourneySuccess(false));// Don't show confirmation and model on Customer360Page
        dispatch(originalRepairAppointmentData(null));
        dispatch(dmcRepairAppointmentData(null));
        dispatch(calendarPageIndex(0));
        dispatch(originalRepairSelectedSlotData(null));
        dispatch(dmcRepairSelectedSlotData(null));
        dispatch(dmcWorkOrderRepairObject(null));
        dispatch(savingCalenderIndex([]));
        dispatch(savingcalenderTrackValue(""));
        dispatch(savingDmcCalenderIndex([]));
        dispatch(savingDmcCalenderTrackValue(""));
        dispatch(DMCChecksavedAnswer(""));
        dispatch(RemoveAllDMCData(null));
        dispatch(showMenuTabs(false));
        dispatch(showFooter(false));
        dispatch(userNavigatedFrom(""));
        dispatch(workOrderRepairObject(null));
        dispatch(getDeterminedContractorDetails(null));
        dispatch(saveSelectedSlotDate(''));
        dispatch(setTriageRepair(false));
        dispatch(originalRepairAppointmentWillNotBeCreated(false));
        dispatch(dmcRepairAppointmentWillNotBeCreated(false));
        dispatch(userChosenAdditionalDescriptionCOUNT(0));
        dispatch(userChosenAdditionalDescription(""));
    }

    const messageWhenOriginalWOAppointed = t('Message_When_Original_WO_Appointed')
        .replace('{0}', determinedcontractordetails?.name).replace('{1}', originalWOAppointmentDate);
    const messageWhenOriginalWOUnAppointed = t('Message_When_Original_WO_UnAppointed')
        .replace('{0}', determinedcontractordetails?.name);
    const messageWhenOriginalWOUnAppointedEMAStandard = t('Message_When_Original_WO_EMA_STANDARD')
        .replace('{0}', determinedcontractordetails?.name);
    const messageWhenOriginalWOUnAppointedEMACatalyst = t('Message_When_Original_WO_EMA_CATALYST');
    const messageWhenEMEOriginalWO = t('Message_When_EME_Original_WO')
        .replace('{0}', determinedcontractordetails?.name);
    const MessageWhenOriginalDefectWOSuccess = t("Message_When_Original_Defect_WO_Success")
        .replace('{0}', determinedcontractordetails?.name);
    const messageWhenDefectOriginalDMEWOSuccess = t('Message_When_DME_WO_Success')
        .replace('{0}', determinedcontractordetails?.name);
    const messageWhenDMWOAppointed = t('Message_When_DM_Appointed_WO_Success')
        .replace('{0}', dmcWOObject?.contractorName).replace('{1}', dmcWOAppointmentDate);
    const messageWhenDMWOUnAppointed = t('Message_When_DM_UnAppointed_WO_Success')
        .replace('{0}', dmcWOObject?.contractorName);
    const messageWhenDMEWOSuccess = t('Message_When_DME_WO_Success')
        .replace('{0}', dmcWOObject?.contractorName);
    const messageWhenDMWOFailed = t('Message_When_DM_WO_Failed');
    const messageWhenOriginalWOFailed = t('Message_When_Original_WO_Failed');
    const SingleWOPropertyInDefectNonDM = t("Single_WO_PropertyInDefect_NonDM")
        .replace('{0}', determinedcontractordetails?.name);
    const messageWhenCatalystDefectTriage = t("Single_WO_CatalystInDefect_DM");
    const SingleWOCatalystInDefectNonDM = t("Single_WO_CatalystInDefect_NonDM");

    let woOriginalMessageToShow = '';
    let woDMCMessageToShow = '';
    var isContactNumberAvailableInMessage = false;
    var isInDefectAndSingleWO = isNullOrUndefined(dmcWOObject);

    if (isNullOrUndefined(originalWOJobNumber)) {
        if (isTriageCase) {
            if (!isNullOrUndefined(userChosenDuplicateQuestion) &&
                !isNullOrUndefined(vulnerabilityAdditionalInformation)
                || !isNullOrUndefined(heatinghotwatercase)) {
                woOriginalMessageToShow = t("DMC_Triage");
            }
            else if (!isNullOrUndefined(vulnerabilityAdditionalInformation)) {
                woOriginalMessageToShow = t("DMC_Triage_Vulnerable_Case");
            }
            else if (!isNullOrUndefined(userChosenDuplicateQuestion)) {
                woOriginalMessageToShow = t("DMC_Triage_Duplicate_Case");
            }
        }
        else if (isCatalystDefectTriageCase) {
            if (isNullOrUndefined(dmcWOObject)) {
                woOriginalMessageToShow = dmcInspectionSorCodes?.includes(userChosenSOR)
                    ? messageWhenCatalystDefectTriage : SingleWOCatalystInDefectNonDM;
                isInDefectAndSingleWO = true;
            }
            else {
                woOriginalMessageToShow = messageWhenCatalystDefectTriage;
            }
        }
        else if (determinedcontractordetails?.statuses?.isEMA && workOrderObject?.isCatalyst) {
            woOriginalMessageToShow = messageWhenOriginalWOUnAppointedEMACatalyst;
        }
        else {
            woOriginalMessageToShow = messageWhenOriginalWOFailed;
            isContactNumberAvailableInMessage = true;
        }
    }
    else if (!isNullOrUndefined(originalWOJobNumber) && isPropertyInDefect) {
        if (isNullOrUndefined(dmcWOObject)) {
            woOriginalMessageToShow = dmcInspectionSorCodes?.includes(userChosenSOR)
                ? workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High
                    ? messageWhenDefectOriginalDMEWOSuccess : MessageWhenOriginalDefectWOSuccess
                : SingleWOPropertyInDefectNonDM;
            isInDefectAndSingleWO = true;
        }
        else {
            woOriginalMessageToShow = MessageWhenOriginalDefectWOSuccess;
        }
    }
    else if (originalWOPriority === RepairPriorityCode.Emergency) {
        woOriginalMessageToShow = messageWhenEMEOriginalWO;
    }
    else if (!isNullOrUndefined(originalRepairSelectedSlotValue)) {
        woOriginalMessageToShow = messageWhenOriginalWOAppointed;
    }
    else if (determinedcontractordetails?.statuses?.isEMA) {
        woOriginalMessageToShow = messageWhenOriginalWOUnAppointedEMAStandard;
    }
    else {
        woOriginalMessageToShow = messageWhenOriginalWOUnAppointed;
    }

    if (isNullOrUndefined(dmcWOJobNumber)) {
        woDMCMessageToShow = messageWhenDMWOFailed;
    }
    else if (dmcWOObject?.priority === RepairPriorityCode.DampAndMouldEmergency) {
        woDMCMessageToShow = messageWhenDMEWOSuccess;
    }
    else if (!isNullOrUndefined(dmcRepairSelectedSlotValue)) {
        woDMCMessageToShow = messageWhenDMWOAppointed;
    }
    else {
        woDMCMessageToShow = messageWhenDMWOUnAppointed;
    }

    return (
        <>
            <HeaderJourney></HeaderJourney>
            <div className='padding-repair'>
                <div className='heading-text'>
                    {woSummaryHeading === t('Multi_WO_Success_Heading') &&
                        <img src={MWS} alt="Success Icon" style={{ width: '2.1875rem', height: '2.1875rem', marginRight: '20px' }} />
                    }
                    {woSummaryHeading === t('Multi_WO_Partial_Success_Heading') &&
                        <img src={MWP} alt="Partial Success Icon" style={{ width: '2.1875rem', height: '2.1875rem', marginRight: '20px' }} />
                    }
                    {woSummaryHeading === t('Multi_WO_Failure_Heading') &&
                        <img src={MWF} alt="Failure Icon" style={{ width: '2.1875rem', height: '2.1875rem', marginRight: '20px' }} />
                    }
                    <h2 className='mb-4 mt-4' style={{ margin: 0 }}>{woSummaryHeading}</h2>
                </div>
                {(!isNullOrUndefined(woSubSummaryHeading))
                    && (
                        <p className='mb-4'>{woSubSummaryHeading}</p>
                    )}
                <div className='div-container'>
                    <h6>{originalWoReferenceToShow}</h6>
                    <p>{originalWODescription}</p>
                    <h6 className='mt-3'>{'What happens next:'}</h6>
                    {isContactNumberAvailableInMessage ? (
                        isMobile ? (
                            <p>
                                {woOriginalMessageToShow}
                                <span
                                    className='underline'
                                    onClick={openMobiledialer}
                                    onKeyDown={openMobiledialer}
                                >
                                    {t('phone_no')}
                                </span>
                            </p>
                        ) : (
                            <p>{woOriginalMessageToShow}{t('phone_no')}</p>
                        )
                    ) : (
                        <p>{woOriginalMessageToShow}</p>
                    )}
                </div>
                {!isInDefectAndSingleWO &&
                    <div className='div-container mt-4'>
                        <h6>{dmcReferenceToShow}</h6>
                        <p>{dmcWOObject?.repairReason}</p>
                        <h6 className='mt-3'>{'What happens next:'}</h6>
                        <p>{woDMCMessageToShow}</p>
                    </div>
                }
                <h6 className='mt-4 mb-4'>{'For all repair details, visit'}
                    <Button
                        className="repair-history"
                        onClick={returnToRepairHistory}>
                        Repair history.
                    </Button>
                </h6>
            </div>
            <div className="footer-actionbtn">
                <div className="col button-container padding-repair">
                    <Button
                        className="request-button"
                        onClick={requestAnotherRepairButtonHandler}>
                        <b>Request another repair</b>
                    </Button>
                    <Button
                        className="return-button"
                        onClick={returnToHomeButtonHandler}>
                        <b>Return to MyPeabody</b>
                    </Button>
                </div>
            </div>
        </>
    )
}
export default RepairFinalDetails;